import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// import HeaderImage from "../../assets/AboutUs/header-image.jpg";
import abg from "../../assets/AboutUs/a-bg.jpg";
import ISOthreesystemsandHSEcertificate from "../../assets/AboutUs/ISOthreesystemsandHSEcertificate.png";
import Utilitymodelandpatentcertificate from "../../assets/AboutUs/Utilitymodelandpatentcertificate.png";
import Hightechenterprisecertificate from "../../assets/AboutUs/Hightechenterprisecertificate.png";
import AAAcreditenterprise from "../../assets/AboutUs/AAAcreditenterprise.png";
import Variousevaluationhonorarycertificates from "../../assets/AboutUs/Variousevaluationhonorarycertificates.png";

const OurStrength = () => {
  return (
    <Box
      id="image"
      sx={{
        position: "relative",
        width: { xs: "100%", sm: "100%" },
        backgroundSize: "cover",
        borderRadius: "10px",

        // outline: "1px solid",
        backgroundImage: `url(${abg})`,
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        component="h1"
        variant="h1"
        sx={{
          display: "flex",
          pt: { xs: 10, sm: 10 },
          pb: { xs: 5, sm: 5 },

          //   flexDirection: { xs: "column", md: "row" },
          flexDirection: "row",
          alignSelf: "center",
          textAlign: "center",
          fontSize: { xs: "4rem", sm: "5rem" },
        }}
      >
        OUR STRENGTH
      </Typography>
      <Typography
        variant="body1"
        textAlign="center"
        color="text.secondary"
        sx={{
          lineHeight: "1.6",
          letterSpacing: "0.5px",
          fontWeight: "bold",
          fontSize: "17px",
        }}
      >
        It has the three ISO management systems and HSE certificate, national
        high-tech enterprise and other honours
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          lineHeight: "1.6",
          letterSpacing: "0.5px",
          fontWeight: "bold",
          fontSize: "14px",
          gap: "20px", // Add gap between the images
          padding: "20px", // Add padding around the images
        }}
      >
        The company has reached the advanced international level in developing
        water control well production and completion tools and researching new
        water control technology. The company independently developed  AICD & AICV
        intelligent water control technology to provide the most competitive
        AlCD intelligent water control well completion technology solutions for
        domestic and foreign oil and gas field users to improve crude oil
        recovery and reduce oil recovery costs. With exquisite technology,
        quality service to provide help for users, win the trust of users, and
        users to create brilliant hand in hand!
        <br />
        The company has established strict and standardized management and R&D
        system, with several system certifications; The company has strong R&D
        and on-site support. It has cooperated with many institutions in
        universities. It has established a flow performance testing laboratory,
        a flow control device performance evaluation simulation laboratory, a
        screen performance evaluation laboratory, etc., which provides a strong
        guarantee for the R & D and on-site support of water control completion
        technology. <br />
        {/* Choosing Reseltech means choosing high-quality and efficient technology and
        services and choosing a trustworthy partner! */}
      </Typography>

      {/* <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-around",
          width: "100%",
          mt: 2,
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          gap: "20px",
          padding: "20px",
        }}
      >
        <Box>
          <img
            src={ISOthreesystemsandHSEcertificate}
            alt="ISO three systems and HSE certificate"
            style={{
              width: "435px",
              height: "auto",
              maxWidth: "100%",
            }}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>
              ISO three systems and HSE certificate
            </span>
          </Box>
        </Box>
        <Box>
          <img
            src={Utilitymodelandpatentcertificate}
            alt="Utility model and patent certificate"
            style={{
              width: "560px", // Adjust width for different screen sizes
              height: "auto",
              maxWidth: "100%", // Ensure the image doesn't exceed its original size
            }}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>
              Utility model and patent certificate
            </span>
          </Box>
        </Box>
        <Box>
          <img
            src={Hightechenterprisecertificate}
            alt="High tech enterprise certificate"
            style={{
              width: "238px", // Adjust width for different screen sizes
              height: "auto",
              maxWidth: "100%", // Ensure the image doesn't exceed its original size
            }}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>
              High tech enterprise certificate
            </span>
          </Box>
        </Box>
        <Box>
          <img
            src={AAAcreditenterprise}
            alt="AAA credit enterprise"
            style={{
              width: "238px", // Adjust width for different screen sizes
              height: "auto",
              maxWidth: "100%", // Ensure the image doesn't exceed its original size
            }}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>AAA credit enterprise</span>
          </Box>
        </Box>
        <Box>
          <img
            src={Variousevaluationhonorarycertificates}
            alt="Various evaluation honorary certificates"
            style={{
              width: "420px",
              height: "auto",
              maxWidth: "100%",
            }}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>
              Various evaluation honorary certificates
            </span>
          </Box>
        </Box>
      </Box> */}
    </Box>
  );
};

export default OurStrength;
